import { render, staticRenderFns } from "./LegionellaRiskAssessmentPage.vue?vue&type=template&id=10d8383a"
import script from "./LegionellaRiskAssessmentPage.vue?vue&type=script&lang=js"
export * from "./LegionellaRiskAssessmentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports